import styled from 'styled-components'
import { Calendar as ReactCalendar } from 'react-calendar'

import Icon from '../Icon'
import { Icons } from '../Icon/types'

export const Container = styled.div``

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH3};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin-bottom: 13.6px;
  text-align: center;
`

export const Legend = styled.p`
  ${({ theme }) => theme.textStyles.body};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin-bottom: 13.6px;
  text-align: center;
`

export const Calendar = styled(ReactCalendar)`
  & .react-calendar__month-view__weekdays {
    border-right: 1px solid ${({ theme }) => theme.colors.greyDark};
  }

  & .react-calendar__month-view__weekdays__weekday {
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    ${({ theme }) => theme.textStyles.WebTitleH2};

    border-left: 1px solid ${({ theme }) => theme.colors.greyDark};
    border-top: 1px solid ${({ theme }) => theme.colors.greyDark};

    & > * {
      text-decoration: none;
    }
  }

  & .react-calendar__month-view__days {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyDark};
    border-right: 1px solid ${({ theme }) => theme.colors.greyDark};
  }

  & .react-calendar__tile {
    ${({ theme }) => theme.textStyles.body}
    color: ${({ theme }) => theme.colors.greyMedium};
    background-color: transparent;
    aspect-ratio: 1/1;
    padding: 1px; /* create spacing */
    border: none;
    border-left: 1px solid ${({ theme }) => theme.colors.greyDark};
    border-top: 1px solid ${({ theme }) => theme.colors.greyDark};
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.colors.greyLighter};
    pointer-events: none;
    position: relative;

    &.available {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.pureBlack};
      pointer-events: auto;
      cursor: pointer;
    }
    &.unavailable {
      background-color: ${({ theme }) => theme.colors.grey};
    }

    &.selected {
      background-color: ${({ theme }) => theme.colors.pureBlack};
      color: ${({ theme }) => theme.colors.pureWhite};
    }
  }

  & .react-calendar__navigation {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 12px;
    position: relative;
    gap: 8px;

    & .react-calendar__navigation__label__labelText {
      display: flex;
      align-items: flex-end;
    }

    & .react-calendar__navigation__label {
      flex-grow: 0 !important;
      border: none;
      background-color: transparent;
    }

    & .react-calendar__navigation__arrow {
      border: none;
      background-color: transparent;
      font-size: 20px;
      cursor: pointer;
    }
  }
`

export const CurrentDayCircle = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 54px;
  height: 54px;
  border: 1px solid ${({ theme }) => theme.colors.greyMedium};
  border-radius: 50%;
`

export const CalendarIcon = styled(Icon).attrs({
  icon: Icons.calendar,
})`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const CalendarMonth = styled.span`
  ${({ theme }) => theme.textStyles.WebTitleH2};
  color: ${({ theme }) => theme.colors.pureBlack};
  position: absolute;
  left: 0;
`
